import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddTreatmentModalService } from '@libs/charting';
import { TranslateModule } from '@ngx-translate/core';
import { CategoryListModule, InputComponent, TooltipModule, AddTreatmentItem } from '@libs/ui-lib';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { DataState } from '@libs/utils';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { ReasonSelectorModalService } from '../reason-selector-modal.service';

@Component({
  selector: 'lib-other-codes',
  imports: [CommonModule, SvgIconComponent, InputComponent, TranslateModule, LottieComponent, CategoryListModule, TooltipModule],
  templateUrl: './other-codes.component.html',
  styleUrl: './other-codes.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OtherCodesComponent {
  public readonly addTreatmentModalService = inject(AddTreatmentModalService);
  private readonly reasonSelectorModalService = inject(ReasonSelectorModalService);

  protected classifications = computed(() => this.addTreatmentModalService.viewModel().classifications);
  protected selectedClassification = computed(() => this.addTreatmentModalService.viewModel().selectedClassification);
  public searchQuery = this.addTreatmentModalService.selectSignal((state) => state.searchQuery);

  public selectedReasons = this.reasonSelectorModalService.selectedReasons;

  protected readonly DataState = DataState;

  protected readonly lottieOptions: AnimationOptions = {
    path: '/assets/animations/loading-spinner.json',
  };

  protected onSearchQueryChange(searchQuery: string): void {
    this.addTreatmentModalService.setSearchQuery(searchQuery);
  }

  protected onClassificationClick(classificationId: string): void {
    this.addTreatmentModalService.setSelectedClassificationId(classificationId);
  }

  public isSelected(item: AddTreatmentItem): boolean {
    return this.selectedReasons().some((selectedItem) => selectedItem.code === item.dentalCode);
  }

  protected selectItem(item: AddTreatmentItem): void {
    this.reasonSelectorModalService.addReason({
      abbreviation: item.abbreviation || item.description,
      code: item.dentalCode,
      name: item.description,
    });
  }

  protected deselectItem(item: AddTreatmentItem): void {
    this.reasonSelectorModalService.removeReason(item.dentalCode);
  }
}
